import React, { ComponentType, useContext, useEffect } from "react";
import { Redirect, Route, RouteProps } from "react-router";
// @ts-ignore
import { store } from "react-notifications-component";
import GlobalData from "../../context/globaldata";

export interface ProtectedRouteProps extends RouteProps {
  authenticationPath: string;
  component: ComponentType<any>;
}

export default function ProtectedRoute({
  component: Component,
  authenticationPath,
  ...rest
}: ProtectedRouteProps) {
  const data = useContext(GlobalData);

  // -------------------------
  // DISABLED USER CHECK
  // -------------------------
  useEffect(() => {
    if (!data.currentUser?.firebase?.uid) return;

    const unsub = data.firestore
      .collection("users")
      .doc(data.currentUser.firebase.uid)
      .onSnapshot((doc: any) => {
        const user = doc.data();
        if (doc.exists && user.disabled === true) {
          data.firebaseAuth.signOut().then(() => {
            localStorage.removeItem("expectSignIn");

            store.addNotification({
              id: "user-disabled",
              message:
                "Your account has been disabled, please contact an admin to enable it again.",
              type: "danger",
              insert: "top",
              container: "top-center",
              animationIn: ["animated", "slideDown"],
              animationOut: ["animated", "slideUp"],
              dismiss: { pauseOnHover: true, duration: 5000 },
            });
          });
        }
      });

    return () => unsub();
  }, [data.currentUser?.firebase?.uid, data.firestore, data.firebaseAuth]);

  // -------------------------
  // AUTH CHECKS
  // -------------------------

  // Not logged in
  if (!data.currentUser?.firebase?.uid) {
    return <Redirect to={authenticationPath} />;
  }

  // -------------------------
  // USER AUTHENTICATED → RENDER PROTECTED COMPONENT
  // -------------------------
  return (
    <Route {...rest} render={(routeProps) => <Component {...routeProps} />} />
  );
}
